export const N70_02 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "combo",
        "title": "Top Performing Territory Managers",
        "colorTheme": 'colorTheme1',
        "orientation": "horizontal",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    },
                     {
                        "name": 'Performance %',
                        "value": 'Performance',
                        "type": 'line',
                        "percent": true
                    }
                ],
                "title": "AgentName",
                "endpoint": "N32.6",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "RegionCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                    }
                }
            }  
        }
    }
}
